/**
 * Creates key:value identifiers used to target ads. E.g. author=jane-doe
 */

export interface IAdTarget {
    key: string
    value: string | string[]
}

export interface IAdTargets {
    [key: string]: IAdTarget['value']
}

export class AdTarget implements IAdTarget {
    constructor(public key: string, public value: IAdTarget['value']) { }
}
